import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Config } from '../../domain/config';
import { DataLoadState, ErrorType, initialDataLoadState } from '../../store/reducers/common';

export type ConfigState = {
  config: Config | null;
} & DataLoadState;

const initialConfigState: ConfigState = {
  ...initialDataLoadState,
  config: null,
};

const slice = createSlice({
  name: 'config',
  initialState: initialConfigState,
  reducers: {
    loadConfig: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    loadConfigSuccess: (state, action: PayloadAction<Config>) => ({
      ...state,
      loading: false,
      config: action.payload,
    }),
    loadConfigFail: (state, { payload: { message } }: PayloadAction<ErrorType>) => ({
      ...state,
      loading: false,
      error: { message },
    }),
  },
});

export const { loadConfig, loadConfigSuccess, loadConfigFail } = slice.actions;

export default slice.reducer;
